import PropTypes from 'prop-types';

export const propTypes = {
    title: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    classNames: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
};
